import React, { useState, useEffect, useRef } from 'react';
// import useWebSocket from 'react-use-websocket';
// import { processWebSocketError } from '../../utils/MessageUtils';
import { formatNumber } from '../../utils/NumberUtils';
import { DEFAULT_SYMBOL } from '../../utils/SymbolUtils';
import BinanceWebSocket from '../BinanceWebSocket/BinanceWebSocket';
import { getMarketTicker24h } from '../../services/SettingsService';

/**
 * props:
 * - symbol
 * - onChange
 */
function SymbolPrice(props) {

    // if (!props.symbol) return <React.Fragment></React.Fragment>;

    const [symbol, setSymbol] = useState(DEFAULT_SYMBOL);
    const [book, setBook] = useState({ bid: '0', ask: '0'});

    useEffect(() => {
        if (!props.symbol) return;
        setSymbol(props.symbol);
    }, [props.symbol]);

    // Marca que o WS está entregando de verdade. Sem isso o REST não teria como saber se deve
    // ceder a vez — e uma guarda ingênua do tipo "já tem preço, não mexe" congelaria o valor no
    // primeiro poll, trocando um book zerado por um book velho (pior: parece certo).
    const wsVivo = useRef(false);

    function onBinanceMessage(b) {
        if (parseFloat(b && b.bid) > 0) wsVivo.current = true;
        setBook(b);
        if (props.onChange) props.onChange(b);
    }

    // 🚨 Achado 08/08: este componente ficou com BID/ASK 0 porque depende do WS DIRETO do browser
    // com a Binance. O dashboard migrou pra REST em 01/07 (o feed !ticker@arr morreu — ver
    // project_binance_ws_migration_dashboard) e o modal Nova Ordem ficou pra trás. Com book zerado
    // o "Preço Total" fica 0 e o fluxo de ordem chega a travar por minNotional.
    // O REST vira a fonte CONFIÁVEL; o WS segue sobrepondo quando funciona (é mais fresco).
    useEffect(() => {
        if (!props.symbol) return;
        let vivo = true;

        async function puxarPreco() {
            try {
                const { book: livro } = await getMarketTicker24h();
                const b = livro && livro[props.symbol];
                if (!vivo || !b) return;
                // O REST fala bestBid/bestAsk; o contrato interno deste componente é bid/ask.
                const normalizado = { bid: `${b.bestBid}`, ask: `${b.bestAsk}` };
                // Cede a vez só se o WS estiver REALMENTE entregando (mais fresco que o cache de 8s).
                if (wsVivo.current) return;
                setBook(normalizado);
                if (props.onChange) props.onChange(normalizado);
            } catch (_) { /* sem preço o modal só perde a dica; não vale quebrar a tela */ }
        }

        puxarPreco();
        const t = setInterval(puxarPreco, 8000);   // mesma cadência do dashboard (cache de 8s no backend)
        return () => { vivo = false; clearInterval(t); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.symbol]);

    /*
    function getBinanceWsUrl() {
        return `${process.env.REACT_APP_BWS_URL}/${symbol.toLowerCase()}@bookTicker`;
    }

    const { lastJsonMessage, sendJsonMessage } = useWebSocket(getBinanceWsUrl(), {
        onOpen: () => {
            console.log(`Connected to Binance Stream ${symbol}`);
            sendJsonMessage({
                method: "SUBSCRIBE",
                params: [`${symbol.toLowerCase()}@bookTicker`],
                id: 1
            })    
        },
        onMessage: () => {
            if (lastJsonMessage) {
                const b = { bid: lastJsonMessage.b, ask: lastJsonMessage.a };
                setBook(b);
                // console.log('bid='+book.bid);
                // console.log('ask='+book.ask);
                if (props.onChange) props.onChange(b);
            }
        },
        onError: (event) => processWebSocketError(event),
        shouldReconnect: (closeEvent) => true,
        reconnectInterval: 3000
    });
    */

    return (
        <div className='form-group'>
            <label>Preço de Mercado</label><br />
            BID: {formatNumber(book.bid)}<br />
            ASK: {formatNumber(book.ask)}
            <BinanceWebSocket symbol={symbol} serviceName={'bookTicker'} onMessage={onBinanceMessage} />
        </div>
    )
}

export default SymbolPrice;